import React, { useContext, useMemo, useState } from 'react';
import { CompanyContext } from '../../../../../../context/CompanyContext';
import { ContainerTypeContext } from '../../../../../../context/ContainerTypeContext';
import { ContainerType } from '../../../../../../types/container_type/containerType';
import { TranslationKey } from '../../../../../../types/translation/TranslationKey';
import { translate } from '../../../../../../types/translation/Translator';
import { ContainerTypeFilter } from '../../../../../../VentoryUI/components/filters/ContainerFilter';
import { CreateButton } from '../../../../../components/Button';
import { SearchFilter } from '../../../../../components/Filter';
import Table, { TableHeader } from '../../../../../components/Table';
import ContainerTypeModal from './ContainerTypeModal';

interface ModalProps {
  open: boolean;
  containerType: ContainerType | undefined;
}

export default function ContainerTypesOverviewPane() {
  const { currentCompany, companies } = useContext(CompanyContext);
  const { containerTypes } = useContext(ContainerTypeContext);

  const allItems = useMemo(() => {
    return [...containerTypes.values()];
  }, [containerTypes]);

  const [items, setItems] = useState(allItems);
  const [modalProps, setModalProps] = useState<ModalProps>({ open: false, containerType: undefined });

  const filter = new ContainerTypeFilter();

  const headers = useMemo(() => {
    const headers: TableHeader<ContainerType>[] = [];

    if (currentCompany.partner) {
      headers.push({
        key: 'company',
        name: translate({ key: TranslationKey.company }),
        text: (item: ContainerType) => companies.get(item.companyId)?.name || '',
      });
    }

    headers.push({
      key: 'name',
      name: translate({ key: TranslationKey.name }),
      text: (item: ContainerType) => item.name,
      position: 'start',
    });

    return headers;
  }, [currentCompany, companies]);

  return (
    <>
      {modalProps.open && (
        <ContainerTypeModal
          containerType={modalProps.containerType}
          open={modalProps.open}
          setOpen={open => setModalProps({ ...modalProps, open })}
        />
      )}

      <div className='flex flex-grow flex-col gap-8'>
        <div className='grid gap-2'>
          <p className='page-title'>{translate({ key: TranslationKey.containerTypesOverviewPaneTitle })}</p>
          <p className='subtitle'>{translate({ key: TranslationKey.containerTypeOverviewPaneSubtitle })}</p>
        </div>

        <div className='flex flex-grow flex-col gap-4'>
          <div className='flex justify-between gap-2'>
            <SearchFilter items={allItems} setItems={setItems} filter={filter} />
            <CreateButton onClick={() => setModalProps({ open: true, containerType: undefined })} />
          </div>
          <Table
            filter={filter}
            items={items}
            totalItemCount={allItems.length}
            onClick={containerType => setModalProps({ open: true, containerType })}
            headers={headers}
          />
        </div>
      </div>
    </>
  );
}
